export class ActiveFilterModel {
  constructor(
    public _id: any, // filter id
    public title: string, // filter title
    public type: string, // filter type (list, advanced, etc.)
    public data?: any, // any data/filters;
    public truncate?: any, // any data/filters;
    public group?: string, // for part attributes, to group them in arrays
  ) {}
}
